import { render, staticRenderFns } from "./recordDelivery.vue?vue&type=template&id=1121fd73&"
import script from "./recordDelivery.vue?vue&type=script&lang=js&"
export * from "./recordDelivery.vue?vue&type=script&lang=js&"
import style0 from "./recordDelivery.vue?vue&type=style&index=0&id=1121fd73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports